<template>
    <div class="text-shape-wrap">
        <span v-for="(item, idx) in data" :key="idx">{{ item.text }}</span>
        <div class="trans-box" v-if="enData && isTranslate && !isEn">
            <span v-for="(item, idx) in enData" :key="idx">{{ item.text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "TextShape",
    props: ["data", "enData", "isTranslate", "isEn"]
};
</script>

<style lang="less" scoped>
.text-shape-wrap {
    position: relative;
    border-radius: 6px;
    padding: 9px 16px;
    max-width: 510px;
    background: #fff;
    border: 1px solid #d8e4f0;
    margin-bottom: 5px;
    width: fit-content;
    white-space: break-spaces;

    &:after {
        position: absolute;
        display: inline-block;
        background: #e9ecf4;
        content: "";
        width: 6px;
        height: 7px;
        background: url("@{zhijiStaticImagePath}class-spr.png") no-repeat;
        top: 10px;
        right: -6px;
        background-position: -370px -80px;
        transform: rotate(180deg);
    }

    .trans-box {
        border-top: 1px solid #d8e4f0;
        margin-top: 8px;
        padding-top: 8px;
    }
}
</style>
